module.exports = ".sidebar-menu .treeview-menu {\n  padding-left: 20px; }\n\n.link-pointer {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/dash/dash.component.scss
// module id = ./src/app/parts/dash/dash.component.scss
// module chunks = main